import { Navigate, useSearchParams } from 'react-router-dom';
// CUSTOM DEFINED HOOK
import useAuth from 'hooks/useAuth';
import useLocation from 'hooks/useLocation';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';

export default function AuthGuard({ children }) {
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get('requestId');
  const email = searchParams.get('requestId');
  const { pathname } = useLocation();
  const { isAuthenticated, selectedCompany } = useAuth();

  useEffect(() => {
    if (pathname === '/admin/accept-connection' && requestId && email) {
      localStorage.setItem(
        'redirectUrl',
        `/admin/accept-connection?requestId=${requestId}&email=${email}`
      );
    }
    if (pathname === '/company-registration') {
      toast.error({
        text: 'Please  Sign out and open link again'
      });
    }
  }, [pathname, requestId]);

  if (isAuthenticated) return <>{children}</>;

  // if (isAuthenticated && selectedCompany) return <>{children}</>;
  //
  // if (!selectedCompany)
  //   return (
  //     <Navigate
  //       replace
  //       to="/choose-company"
  //       state={{
  //         from: pathname
  //       }}
  //     />
  //   );

  return (
    <Navigate
      replace
      to="/login"
      state={{
        from: pathname
      }}
    />
  );
}
